import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f0cb388")

_pushScopeId("data-v-7f0cb388")
const _hoisted_1 = { class: "display-flex set-page-list-width" }
const _hoisted_2 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_list_choose_tag = _resolveComponent("list-choose-tag")
  const _component_access_group_dialog = _resolveComponent("access-group-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_cus_button, {
          type: "blue",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowAccessGroupDialog=true))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextNew), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_list_choose_tag, {
      class: "set-page-list-width",
      "choose-label-deal": (item)=>item.Name,
      headers: _ctx.headers,
      update: _ctx.updateToList,
      "request-data": _ctx.listRequestData,
      "selected-item": _ctx.selectItem,
      dealList: _ctx.dealList,
      "is-clear-check": false,
      showCheck: "OnlyCheck",
      action: false,
      onMultipleSelect: _ctx.multipleSelect
    }, {
      SchedulerTypeSlot: _withId((data) => [
        _createTextVNode(_toDisplayString(_ctx.SchedulerTypeText[data.scope.SchedulerType]), 1)
      ]),
      TimeSlot: _withId((data) => [
        (data.scope.SchedulerType === _ctx.access.never)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(`${data.scope.BeginTime} - ${data.scope.EndTime}`), 1))
          : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(`${data.scope.StartTime} - ${data.scope.StopTime}`), 1))
      ]),
      _: 1
    }, 8, ["choose-label-deal", "headers", "update", "request-data", "selected-item", "dealList", "onMultipleSelect"]),
    (_ctx.isShowAccessGroupDialog)
      ? (_openBlock(), _createBlock(_component_access_group_dialog, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowAccessGroupDialog=false)),
          onSuccess: _ctx.newSuccess
        }, null, 8, ["onSuccess"]))
      : _createCommentVNode("", true)
  ]))
})